module.exports = __webpack_public_path__ + "static/media/heart3.c3c58481.svg";